
import { defineComponent } from 'vue'

import OkButton from '@/modules/OktellModule/components/OkButton/index.vue'

export default defineComponent({
    components: {
        OkButton,
    },
    props: {
        title: {
            type: String,
            default: null,
        },
        confirmButtonText: {
            type: String,
            default: null,
        },
        cancelButtonText: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['confirm', 'cancel'],
    setup(props, { emit }) {
        const onConfirm = () => {
            emit('confirm')
        }

        const onCancel = () => {
            emit('cancel')
        }

        return {
            onConfirm,
            onCancel,
        }
    },
})
